module.exports = __webpack_public_path__ + "img/data-cover-1.f429b424.png";